import { lazy } from "react";
import { getRoute } from "util/react";

export const NotificationsRoute = getRoute(
  { fullPath: "/:locale?/notifications" },
  "notifications",
  lazy(() => import("./index")),
  null,
);

export const NotificationRoute = getRoute(
  { fullPath: "/:locale?/notifications/:id" },
  "notifications/:id",
  lazy(() => import("./notification")),
  null,
);

const NotificationListRoute = (
  <>
    {NotificationsRoute}
    {NotificationRoute}
  </>
);

export default NotificationListRoute;
